import {
    Popover,
    PopoverTrigger,
    PopoverSurface,
    makeStyles,
    Input,
    Label,
    Text,
    Subtitle2,
    mergeClasses,
} from '@fluentui/react-components';
import { useCommonStyles } from '../../common/Styles/commonStyles';
import { Case, Task } from '../../../data/types';
import { Column, Row } from '../../common';
import { useCaseService } from '../../../data/services/useCaseService';
import { useActiveTimer } from '../../../data/services/useActiveTimer';
import { CaseControl } from '../../controls/CaseControl';
import { TimeTrackingTimerControl } from '../../controls/TimeTrackingTimerControl';
import { TimeTrackingTimerBarControl } from '../../controls/TimeTrackingTimerBarControl';
import { useTaskService } from '../../../data/services';

const useStyles = makeStyles({
    acctPop: {
        maxWidth: '400px',
    },
    hoursInput: {
        width: '7rem',
        height: '3rem',
        fontSize: '36px',
    },
});

type ActiveTimerEntryPopoverProps = {
    children?: JSX.Element;
};
export const ActiveTimerEntryPopover = (props: ActiveTimerEntryPopoverProps) => {
    const { children } = props;

    //Hooks
    const caseService = useCaseService();
    const taskService = useTaskService();
    const { activeTimeEntry, elapsedHours } = useActiveTimer();

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const acctPopSurfaceClasses = mergeClasses(commonStyles.utility.flexColumn, styles.acctPop);

    //Logic
    const getCase = () => {
        if (activeTimeEntry?.caseId) {
            const caseObj = caseService.cases.find((c: Case) => c.caseId === activeTimeEntry?.caseId);
            return caseObj;
        }
    };
    const getTask = () => {
        if (activeTimeEntry?.taskId) {
            const taskObj = taskService.tasks.find((t: Task) => t.taskId === activeTimeEntry?.taskId);
            return taskObj;
        }
    };

    return (
        <Popover positioning='below-end'>
            <PopoverTrigger disableButtonEnhancement>{children}</PopoverTrigger>
            <PopoverSurface tabIndex={-1} className={acctPopSurfaceClasses}>
                <Column gap='medium'>
                    <Subtitle2>Active Timer</Subtitle2>
                    <TimeTrackingTimerBarControl task={getTask()} size='large' showClose showComplete showCaseName showTaskTitle />
                </Column>
            </PopoverSurface>
        </Popover>
    );
};
